import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    // Clear any existing listeners to prevent duplicates during hot reload
    this.boundHandleClick = this.handleClick.bind(this);
    this.element.addEventListener('click', this.boundHandleClick);
  }

  disconnect() {
    if (this.boundHandleClick) {
      this.element.removeEventListener('click', this.boundHandleClick);
      this.boundHandleClick = null;
    }
  }

  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    // Show tooltip if Bootstrap is available
    if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
      const tooltip = new bootstrap.Tooltip(event.target, {
        trigger: 'manual',
        placement: 'top',
        title: 'Disabled in demo',
      });

      tooltip.show();
      setTimeout(() => {
        tooltip.dispose();
      }, 1500);
    }
  }
}
